/**
 * 浏览器storage
 */
const STORAGE_KEY = '__com_sankuai_oa_it_ssoweb__';

// 获取页面缓存数据LocalStorage
const getLocalStorage = () => {
  return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
};

// 获取页面缓存数据SessionStorage
const getSessionStorage = () => {
  return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
};

export const StorageService = {
  // localStorage
  getItem: (key, defaultValue?) => {
    const data = getLocalStorage();
    return data[key] || defaultValue || null;
  },
  setItem: (key, value) => {
    const data = getLocalStorage();
    data[key] = value;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },
  removeItem: (key) => {
    const data = getLocalStorage();
    delete data[key];
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },
  clear: () => {
    const data = {};
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },
  // sessionStorage
  getItemSession: (key, defaultValue?) => {
    const data = getSessionStorage();
    return data[key] || defaultValue || null;
  },
  setItemSession: (key, value) => {
    const data = getSessionStorage();
    data[key] = value;
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },
  removeItemSession: (key) => {
    const data = getSessionStorage();
    delete data[key];
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },
  clearSession: () => {
    const data = {};
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }
};
